import React from "react";
import { SearchIcon } from "../../Assets/Icons";

const SearchBar = (searchProps) => {
  return (
    <div className="search-bar">
      <input type="text" className="form-control" autoComplete="off" {...searchProps} />
      <span className="search-btn">
        <SearchIcon />
      </span>
    </div>
  );
};

export default SearchBar;
